/**
 * @generated SignedSource<<1b30d6e6bdde726647ee867b56d74a84>>
 * @relayHash 09e45e2931fc139e0c5113f8346d5789
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6172ee3fc5176f6082256c171d227c0d870a61f22fc1c1ae12378d60c7adaf47

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessTimelineEmbedQuery } from './src_jiraBusinessTimelineEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessTimelineEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6172ee3fc5176f6082256c171d227c0d870a61f22fc1c1ae12378d60c7adaf47",
    "metadata": {},
    "name": "src_jiraBusinessTimelineEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
